import { AddExamCenterMemberButton } from '@exam-center/exam-center-member-management';
import { GroupOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ExamCenterMemberListNoRowsOverlay() {
  return (
    <NoRowsOverlay
      icon={GroupOutlinedIcon}
      title='ยังไม่มีสมาชิก'
      description='คลิกปุ่มด้านล่างเพื่อเพิ่มสมาชิกใหม่'
      action={<AddExamCenterMemberButton variant='outlined' size='large' />}
    />
  );
}
